<cov-side-panel-grid>
  <div ngProjectAs="header" class="d-flex flex-column gap-4">
    <h2>{{ 'inquiries.sideDrawer.orderSelectPanel.title' | transloco }}</h2>
    <p class="content-text">{{ 'inquiries.sideDrawer.orderSelectPanel.subTitle' | transloco }}</p>
  </div>
  <div ngProjectAs="content">
    <div class="d-flex gap-4 align-items-end">
      <mat-form-field class="d-flex flex-column gap-2 p-1 mt-8">
        <label for="searchOrder">
          {{ 'inquiries.sideDrawer.orderSelectPanel.searchLabel' | transloco }}
        </label>
        <input
          id="searchOrder"
          [formControl]="searchInput"
          matNativeControl
          [matAutocomplete]="auto"
        />
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayOrder">
          @for (order of filteredOrders$ | async; track $index) {
            <mat-option [value]="order">{{ displayOrder(order) }}</mat-option>
          }
        </mat-autocomplete>

        @if (loading()) {
          <mat-spinner class="position-absolute mb-2 spinner" [diameter]="18" />
        } @else {
          <cov-icon
            class="search-icon cov-fs-muted"
            matSuffix
            [iconName]="IconName.SEARCH"
          ></cov-icon>
        }
      </mat-form-field>
    </div>
  </div>

  <div ngProjectAs="footer" class="d-flex justify-content-between">
    <cov-button [buttonType]="ButtonType.SECONDARY" (click)="cancelOrderSelect.emit(PageId.INTRO)">
      {{ 'global.ui.button.cancel' | transloco }}
    </cov-button>

    <cov-button [buttonType]="ButtonType.PRIMARY" (click)="selectOrder()">
      {{ 'global.ui.button.choose' | transloco }}
    </cov-button>
  </div>
</cov-side-panel-grid>
